module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1900.d0f4fe55.svg";